/**
 * Link de rastreio "ao vivo" na própria transportadora, a partir do código.
 * Resolve a transportadora pelo nome; se não vier, infere pelo padrão do código
 * (UPS `1Z…`, Correios `XX#########XX`). Permite ver "onde está / saiu para
 * entrega" no site oficial sem precisar de uma API paga.
 */
export function carrierTrackingUrl(carrier: string | undefined, code: string): string | undefined {
  const e = encodeURIComponent(code.trim());
  let c = (carrier ?? '').toLowerCase();
  if (!c) {
    if (/^1z/i.test(code)) c = 'ups';
    else if (/^[a-z]{2}\d{9}[a-z]{2}$/i.test(code)) c = 'correios';
  }
  if (c.includes('fedex')) return `https://www.fedex.com/fedextrack/?trknbr=${e}`;
  if (c.includes('ups')) return `https://www.ups.com/track?loc=pt_BR&tracknum=${e}`;
  if (c.includes('dhl')) return `https://www.dhl.com/br-pt/home/rastreamento.html?tracking-id=${e}`;
  if (c.includes('correios')) return `https://rastreamento.correios.com.br/app/index.php?objeto=${e}`;
  return undefined;
}
